import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export function MaskedLines({ lines, as: Tag = "h1", className = "", delay = 0, inView = false }) {
  if (inView) {
    return (
      <Tag
        className={className}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
      >
        {lines.map((line, i) => (
          <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
            <motion.span
              className="block will-change-transform"
              variants={{
                hidden: { y: "112%" },
                show: {
                  y: "0%",
                  transition: { duration: 1.05, delay: delay + i * 0.1, ease: EASE },
                },
              }}
            >
              {line}
            </motion.span>
          </span>
        ))}
      </Tag>
    );
  }
  return (
    <Tag className={className} initial="hidden" animate="show">
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className="block will-change-transform"
            variants={{
              hidden: { y: "112%" },
              show: {
                y: "0%",
                transition: { duration: 1.05, delay: delay + i * 0.1, ease: EASE },
              },
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}

export function FadeUp({ children, className = "", delay = 0, y = 28 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function Overline({ children, light = false }) {
  return (
    <p
      className={`font-mono text-[11px] font-medium uppercase tracking-[0.3em] ${
        light ? "text-gold" : "text-pine/60"
      }`}
    >
      {children}
    </p>
  );
}
